import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { ENV } from 'shared/ENV';

export const isProductionEnvironment = (): boolean =>
  ['production', 'production-beta'].includes(ENV.VITE_ENV);

/**
 * Checks if the device is a phone considering the device orientation
 */
export const isPhone = (): boolean =>
  Math.min(window.innerWidth, window.innerHeight) < 480;

// __APP_VERSION__ comes from package.json version: see vite.config.ts
export const getWebAppVersion = (): string =>
  // @ts-expect-error - better not to fix this typing globally so we always use this function
  __APP_VERSION__;

/**
 * Gets the current app version (for native or web), optimizing for performance
 * by returning a cached value after the first call.
 */
export const getAppVersion = async (): Promise<string> => {
  if (!Capacitor.isNativePlatform()) {
    return getWebAppVersion();
  }

  const cachedAppVersion = sessionStorage.getItem('appVersion');

  if (cachedAppVersion) {
    return cachedAppVersion;
  }

  const { version } = await App.getInfo();
  sessionStorage.setItem('appVersion', version);
  return version;
};
